"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.HiddenColumns = void 0;
var _hiddenColumns = require("./hiddenColumns");
exports.PLUGIN_KEY = _hiddenColumns.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _hiddenColumns.PLUGIN_PRIORITY;
exports.HiddenColumns = _hiddenColumns.HiddenColumns;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/hiddenColumns/index.js
// module id = 1435
// module chunks = 0